import { ICampaignTemplate } from '@dataTypes/marketing.type'
import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import { logger } from '@utils/safeLogger'
import { toApiError } from '../errors/api-error'

// Constants
const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_MARKETING', '')

const headers = {
  'Content-Type': 'application/json',
}

// Types
interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

type CampaignTemplatesResponseData = {
  campaign_templates?: ICampaignTemplate[]
}

type CampaignTemplateResponseData = {
  campaign_template?: ICampaignTemplate
}

type GenericResponseData = Record<string, unknown>

export type GetAllCampaignTemplateResponse =
  ApiResponse<CampaignTemplatesResponseData>
export type UpdateCampaignTemplateResponse =
  ApiResponse<CampaignTemplatesResponseData>
export type CreateCampaignTemplateResponse =
  ApiResponse<CampaignTemplateResponseData>

// API Functions
export const getAllCampaignTemplates =
  async (): Promise<GetAllCampaignTemplateResponse> => {
    try {
      const response = await axios.get<GetAllCampaignTemplateResponse>(
        `${BUSINESS_LAYER_API}/api/v1/campaign/template/all`,
        {
          headers,
        },
      )

      return response.data
    } catch (e: unknown) {
      logger.error('Error in getAllCampaignTemplates:', e)
      throw toApiError(e, 'An unknown error occurred')
    }
  }

export const updateCampaignTemplateById = async (
  campaign_template_id: string,
  updatedData: Partial<ICampaignTemplate>,
): Promise<UpdateCampaignTemplateResponse> => {
  try {
    const response = await axios.put<UpdateCampaignTemplateResponse>(
      `${BUSINESS_LAYER_API}/api/v1/campaign/template`,
      { campaign_template_id, data: updatedData },
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in updateCampaignTemplateById:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const createCampaignTemplate = async (
  campaignTemplateDetails: ICampaignTemplate,
): Promise<CreateCampaignTemplateResponse> => {
  try {
    const response = await axios.post<CreateCampaignTemplateResponse>(
      `${BUSINESS_LAYER_API}/api/v1/campaign/template`,
      campaignTemplateDetails,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in createCampaignTemplate:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}

export const deleteCampaignTemplateById = async (
  campaignTemplateId: string,
): Promise<CreateCampaignTemplateResponse> => {
  try {
    const response = await axios.delete<CreateCampaignTemplateResponse>(
      `${BUSINESS_LAYER_API}/api/v1/campaign/template/${campaignTemplateId}`,
      {
        headers,
      },
    )

    return response.data
  } catch (e: unknown) {
    logger.error('Error in deleteCampaignTemplateById:', e)
    throw toApiError(e, 'An unknown error occurred')
  }
}
